// Constante de site centralizate — schimbi într-un singur loc.
export const SITE_URL = 'https://vorba.dev'

// Booking real (Cal.com) — folosit pe Contact + cele 5 CTA de departament.
export const BOOKING_URL = 'https://cal.com/vorba.dev/15min'
